/* app/js/src/components/common/collapse-panel/collapse-panel.component.scss */
/*# sourceMappingURL=collapse-panel.component.css.map */
